import React, { useState } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

// @material-ui/icons
import Info from "@material-ui/icons/Info";
import Email from "@material-ui/icons/Email";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Input from "components/CustomInput/Input.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import styles from "./Styles/LoginPageStyles";
import { useTranslation } from "react-i18next";

const API_URL = process.env.REACT_APP_API;
const useStyles = makeStyles(styles);

export default function ResetPassword() {
  const classes = useStyles();
  const { t } = useTranslation("passwordRecovery");

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [reqError, setReqError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const requestReset = async () => {
    if (isSubmitting) return;

    setReqError(null);
    setMessage(null);
    setIsSubmitting(true);

    try {
      const req = await fetch(`/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });

      const resp = await req.json();

      if (!req.ok || resp.ok === false) {
        setReqError(resp.mensaje);
        return;
      }

      setMessage(t("success"));
    } catch (err) {
      setReqError(err.message);
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    requestReset();
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={10}>
          <Card className={classes.cardSignup}>
            <h2 className={classes.cardTitle}>{t("title")}</h2>

            <CardBody>
              <GridContainer justify="center" spacing={3}>
                <GridItem xs={12} sm={10} md={6}>
                  <InfoArea
                    title={t("title")}
                    description={t("description")}
                    icon={Info}
                    iconColor="primary"
                  />

                  <form className={classes.form} onSubmit={handleSubmit}>
                    <Input
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <Email className={classes.inputAdornmentIcon} />
                          </InputAdornment>
                        ),
                        placeholder: t("email"),
                        value: email,
                        onChange: (e) => setEmail(e.target.value),
                      }}
                    />

                    <Box mt={1} className={classes.center}>
                      <Typography
                        variant="body2"
                        style={{
                          color: "green",
                          minHeight: message ? 24 : 0,
                          wordBreak: "break-word",
                        }}
                      >
                        {message || ""}
                      </Typography>

                      <Typography
                        variant="body2"
                        style={{
                          color: "red",
                          minHeight: reqError ? 24 : 0,
                          wordBreak: "break-word",
                        }}
                      >
                        {reqError || ""}
                      </Typography>
                    </Box>

                    <Box mt={2} className={classes.center}>
                      <Button round color="primary" type="submit" disabled={isSubmitting}>
                        {t("buttons.send")}
                      </Button>
                    </Box>
                  </form>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}